import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import ReactGA from "react-ga";

export default function Links() {
    const { linkCode } = useParams();
    const apiUrl = "https://api.maejo.link/?code=";
    const apiToken = "Bearer 0dd39219240c3b0db76989fdd4f0a242b2ca2fb0";
    // const [linkUrl, setLinkUrl] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const instance = axios.create({
            baseURL: apiUrl,
            headers: {
                Authorization: apiToken,
            },
        });
        instance.get(linkCode).then((res) => {
          if (res.data) {
            console.log("linkcode:", linkCode);
            // setLinkUrl(res.data);
            ReactGA.initialize("G-94BF06KK8G");
            ReactGA.pageview(location.pathname + location.search);
            window.location.replace(res.data)
            // navigate(res.data);
          } else {
            navigate(`/?alert=warning&msg=รหัสลิงก์ผิดพลาด`);
          }
        })
        // eslint-disable-next-line
    }, []);
}
